import { useState, useCallback } from "react";
import { Seo } from "@/components/Seo";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import IntroVideo from "@/components/site/IntroVideo";
import ClassShowcase from "@/components/site/ClassShowcase";
import Manifesto from "@/components/site/Manifesto";
import AboutAuthor from "@/components/site/AboutAuthor";
import EnrollSection from "@/components/site/EnrollSection";
import GalleryPage from "@/pages/GalleryPage";
import { TrustStrip, HowItWorks, FaqSection, CtaBanner } from "@/components/site/ConversionSections";
import Testimonials from "@/components/site/Testimonials";
import WaitlistSection from "@/components/site/WaitlistSection";
import FreeAssessmentCta from "@/components/site/FreeAssessmentCta";
import VeteranStory from "@/components/site/VeteranStory";
import NewsletterSignup from "@/components/site/NewsletterSignup";

export default function Home() {
  const [preselect, setPreselect] = useState("");

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  const goEnroll = useCallback((course) => {
    if (typeof course === "string") setPreselect(course);
    scrollToId("enroll");
  }, [scrollToId]);

  return (
    <main data-testid="page-home" className="bg-[#050505]">
      <Seo
        title="Delta DL Enterprise, LLC — Nursing Algebra, Books, Art & Tutoring"
        description="Online classes in Nursing Algebra, Leadership and Math Tutoring, plus published books and artwork from The Delta DL Enterprise, LLC Collection. Tampa, Florida."
        path="/"
      />
      <Hero onEnroll={() => goEnroll()} />
      <Marquee />
      <TrustStrip />
      <IntroVideo />
      <ClassShowcase onEnroll={goEnroll} />
      <FreeAssessmentCta />
      <HowItWorks />
      <GalleryPage
        only="art"
        overline="The Delta DL Enterprise, LLC Collection"
        collectionTag="A Veteran-Owned Business"
        heading="Meaningful Art to Beautify Spaces."
        subtitle="Transform your home or office with expressive wall art inspired by humanity, nature, and imagination. Explore artwork created by Dennis Louden alongside AI-generated designs developed through his creative direction and selection."
        note="From bold conversation pieces to calming compositions, discover art that reflects your style and brings character to your space. Each canvas is printed to order, especially for you. Individual listings describe how each artwork was created. Custom original pieces are available — share your vision, and Dr. Louden will create a piece especially for you. Find the piece that speaks to you."
        noteAction={{ label: "Shop the Collection", href: "#art-collection" }}
      />
      <GalleryPage
        only="books"
        overline="The Library"
        heading="Books"
        subtitle="Published books by Dr. Dennis Louden — practical knowledge, real-world experience, and personal transformation."
        note="To order a book, tap any cover to see its details and request it — we'll confirm your order personally by email. Questions about titles, bulk orders, or signed copies welcome:"
      />
      <Manifesto />
      <AboutAuthor />
      <VeteranStory />
      <Testimonials />
      <FaqSection />
      <CtaBanner onEnroll={() => goEnroll()} />
      <EnrollSection preselect={preselect} onConsumePreselect={() => setPreselect("")} />
      <NewsletterSignup />
      <WaitlistSection />
    </main>
  );
}
